import React, { ReactNode, useState } from 'react';
import styles from './readmore.module.scss';

export interface ReadMoreProps {
    height: number;
    children?: ReactNode;
}

const ReadMore = ({ height, children }: ReadMoreProps) => {
    const [collapse, setCollapse] = useState(true);

    const toggle = () => {
        setCollapse(!collapse);
    };

    return (
        <div className={styles.readMoreContainer}>
            <div
                className={`${styles.readMore} ${collapse ? styles.collapse : ''}`}
                style={{ height: collapse ? `${height}px` : 'auto' }}
            >
                {children}
            </div>
            <div className={`${styles.showMore} ${collapse ? styles.more : styles.less}`}>
                {collapse ? (
                    <span onClick={toggle}>Read More &#8595;</span>
                ) : (
                    <span onClick={toggle}>Read less &#8593;</span>
                )}
            </div>
        </div>
    );
};

export default ReadMore;
